/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ClientPortalFormSubmissionPageResponse } from '../models/client-portal-form-submission-page-response';
import { ClientPortalFormSubmissionResponse } from '../models/client-portal-form-submission-response';
import { ClientPortalFullSaveRequest } from '../models/client-portal-full-save-request';
import { ClientPortalStepSaveRequest } from '../models/client-portal-step-save-request';

/**
 * Form Submission APIs
 */
@Injectable({ providedIn: 'root' })
export class FormSubmissionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listClientPortalFormSubmissions()` */
  static readonly ListClientPortalFormSubmissionsPath =
    '/api/v1/forms/client-portal';

  /**
   * List client portal form submissions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listClientPortalFormSubmissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listClientPortalFormSubmissions$Response(
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      search?: string;
      statuses?: Array<'STARTED' | 'DRAFT' | 'SUBMITTED'>;
      from?: string;
      to?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionPageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.ListClientPortalFormSubmissionsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('statuses', params.statuses, {});
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionPageResponse>;
        })
      );
  }

  /**
   * List client portal form submissions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listClientPortalFormSubmissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listClientPortalFormSubmissions(
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      search?: string;
      statuses?: Array<'STARTED' | 'DRAFT' | 'SUBMITTED'>;
      from?: string;
      to?: string;
    },
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionPageResponse> {
    return this.listClientPortalFormSubmissions$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionPageResponse>
        ): ClientPortalFormSubmissionPageResponse => r.body
      )
    );
  }

  /** Path part for operation `startClientPortalFormDraft()` */
  static readonly StartClientPortalFormDraftPath =
    '/api/v1/forms/client-portal';

  /**
   * Start a new client portal form submission draft.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startClientPortalFormDraft()` instead.
   *
   * This method doesn't expect any request body.
   */
  startClientPortalFormDraft$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.StartClientPortalFormDraftPath,
      'post'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionResponse>;
        })
      );
  }

  /**
   * Start a new client portal form submission draft.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startClientPortalFormDraft$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startClientPortalFormDraft(
    params?: {},
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionResponse> {
    return this.startClientPortalFormDraft$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionResponse>
        ): ClientPortalFormSubmissionResponse => r.body
      )
    );
  }

  /** Path part for operation `getClientPortalFormSubmission()` */
  static readonly GetClientPortalFormSubmissionPath =
    '/api/v1/forms/client-portal/{id}';

  /**
   * Get details of a client portal form submission by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientPortalFormSubmission()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientPortalFormSubmission$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.GetClientPortalFormSubmissionPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionResponse>;
        })
      );
  }

  /**
   * Get details of a client portal form submission by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientPortalFormSubmission$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientPortalFormSubmission(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionResponse> {
    return this.getClientPortalFormSubmission$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionResponse>
        ): ClientPortalFormSubmissionResponse => r.body
      )
    );
  }

  /** Path part for operation `saveClientPortalFormStep()` */
  static readonly SaveClientPortalFormStepPath =
    '/api/v1/forms/client-portal/{id}';

  /**
   * Save a single step payload for a client portal form submission.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveClientPortalFormStep()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveClientPortalFormStep$Response(
    params: {
      id: number;
      step: number;
      body: ClientPortalStepSaveRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.SaveClientPortalFormStepPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.query('step', params.step, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionResponse>;
        })
      );
  }

  /**
   * Save a single step payload for a client portal form submission.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveClientPortalFormStep$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveClientPortalFormStep(
    params: {
      id: number;
      step: number;
      body: ClientPortalStepSaveRequest;
    },
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionResponse> {
    return this.saveClientPortalFormStep$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionResponse>
        ): ClientPortalFormSubmissionResponse => r.body
      )
    );
  }

  /** Path part for operation `submitClientPortalForm()` */
  static readonly SubmitClientPortalFormPath =
    '/api/v1/forms/client-portal/{id}/submit';

  /**
   * Submit a client portal form submission.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitClientPortalForm()` instead.
   *
   * This method doesn't expect any request body.
   */
  submitClientPortalForm$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.SubmitClientPortalFormPath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionResponse>;
        })
      );
  }

  /**
   * Submit a client portal form submission.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitClientPortalForm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  submitClientPortalForm(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionResponse> {
    return this.submitClientPortalForm$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionResponse>
        ): ClientPortalFormSubmissionResponse => r.body
      )
    );
  }

  /** Path part for operation `saveClientPortalFormFull()` */
  static readonly SaveClientPortalFormFullPath =
    '/api/v1/forms/client-portal/{id}/full';

  /**
   * Save the full draft of a client portal form submission.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveClientPortalFormFull()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveClientPortalFormFull$Response(
    params: {
      id: number;
      body: ClientPortalFullSaveRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientPortalFormSubmissionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormSubmissionService.SaveClientPortalFormFullPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientPortalFormSubmissionResponse>;
        })
      );
  }

  /**
   * Save the full draft of a client portal form submission.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveClientPortalFormFull$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveClientPortalFormFull(
    params: {
      id: number;
      body: ClientPortalFullSaveRequest;
    },
    context?: HttpContext
  ): Observable<ClientPortalFormSubmissionResponse> {
    return this.saveClientPortalFormFull$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientPortalFormSubmissionResponse>
        ): ClientPortalFormSubmissionResponse => r.body
      )
    );
  }
}
